import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AddressLookupModule } from './components/address-lookup/address-lookup.module';
import { AvatarModule } from './components/avatar';
import { ButtonModule } from './components/button';
import { ButtonToggleModule } from './components/button-toggle/button-toggle.module';
import { CardDocModule } from './components/card-doc/card-doc.module';
import { CardModule } from './components/card';
import { CarouselModule } from './components/carousel/carousel.module';
import { ChipsAutocompleteModule } from './components/chips-autocomplete';
import { CircularProgressModule } from './components/circular-progress';
import { ContextMenuModule } from './components/context-menu';
import { CursorModule } from './components/cursor';
import { DialogModule } from './components/dialog';
import { DrawerModule } from './components/drawer';
import { ExpansionModule } from './components/expansion';
import { FileDragAndDropModule } from './components/file-drag-and-drop';
import { FlipCardModule } from './components/flip-card';
import { FooterModule } from './components/footer';
import { FormFieldModule } from './components/form-field';
import { HeroBasicModule } from './components/hero-basic/hero-basic.module';
import { IdleDialogComponent } from './components/idle-dialog/idle-dialog.component';
import { ImageComponent } from './components/image';
import { LayoutModule } from './components/layouts';
import { LinkDirective } from './components/link/link.directive';
import { ListModule } from './components/list';
import { LoadingOverlayModule } from './components/loading-overlay';
import { LogoComponent } from './components/logo/logo.component';
import { MainMenuModule } from './components/main-menu';
import { MenuButtonModule } from './components/menu-button';
import { NavListModule } from './components/nav-list/nav-list.module';
import { NavbarModule } from './components/navbar';
import { ResourceCardModule } from './components/resource-card';
import { ResourceCarouselModule } from './components/resource-carousel';
import { SearchFieldModule } from './components/search-field';
import { SelectBoxModule } from './components/select-box';
import { SkeletonModule } from './components/skeleton';
import { SmartGridComponent } from './components/smart-grid';
import { SnackbarModule } from './components/snackbar';
import { StickyDrawerModule } from './components/sticky-drawer';
import { StretchedLinkDirective } from './components/stretched-link/stretched-link.directive';
import { TagModule } from './components/tag';
import { TagPickerModule } from './components/tag-picker/tag-picker.module';
import { TextBoxModule } from './components/text-box/text-box.module';
import { ToolBarModule } from './components/toolbar';
import {
  ClickOutsideDirectiveModule,
  DatepickerMaskDirective,
  KeyboardFocusDirective,
  ResizeObserverModule,
} from './directives';
import { NavigateBackDirective } from './directives/navigate-back/navigate-back.directive';
import { PreventBubbleDirective } from './directives/prevent-bubble/prevent-bubble.directive';
import { ThemeColorDirective } from './directives/theme-color/theme-color.directive';
import { MatTableAddonsDirective } from './components/mat-table/mat-table-addons.directive';
import { InitialsPipe } from './pipes/initials.pipe';
import { NegatePipe } from './pipes/negate.pipe';
import { StringColorPipe } from './pipes/string-color.pipe';
import { TimesWithPipe } from './pipes/times-with.pipe';
import { ValuesByPipe } from './pipes/values-by.pipe';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { MatTooltipAddonsDirective } from './components/mat-tooltip/mat-tooltip-addons.directive';
import { BreadcrumbsModule } from './components/breadcrumbs';
import { AddressPipe } from './pipes/address.pipe';
import { FaqToolbarComponent } from './components/faq-toolbar/faq-toolbar.component';
import { LsosLogoComponent } from './components/lsos-logo/lsos-logo.component';
import { IndicatorComponent } from './components/indicator';
import { NotificationBarModule } from './components/notification-bar';
import { FloatingActionsModule } from './components/floating-actions';
import { ScrollTopModule } from './components/scroll-top';
import { FloatingPanelModule } from './components/floating-panel';
import { SelectorModule } from './components/selector/selector.module';
import { MatAutocompleteAddonsDirective } from './components/mat-autocomplete/mat-autocomplete-addons.directive';
import { LoadingDialogComponent } from './components/loading-dialog';
import { NorwayLogoComponent } from './components/norway-logo';
import { AlertModule } from './components/alert/alert.module';
import { AlertLiteComponent } from './components/alert';
import { LayoutDualColModule } from './components/layout-dual-col';
import { TopIconCardModule } from './components/top-icon-card/top-icon-card.module';
import { MatFormFieldYearPickerDirective } from './components/mat-datepicker/mat-form-field-year-picker.directive';
import { SignaturePadComponent } from './components/signature-pad/signature-pad.component';
import { SignaturePadDatuUrlControlDirective } from './components/signature-pad/signature-pad-datu-url-control.directive';
import { RoutedLabelModule } from './components/routed-label';
import { PartnerLogoComponent } from './components/partner-logo';
import { MatCheckboxAddonsDirective } from './components/mat-checkbox/mat-checkbox-addons.directive';
// import { MatTabAddonsDirective } from './components/mat-tab/mat-tab-addons.directive';

const publicApi = [
  AddressLookupModule,
  AlertModule,
  AvatarModule,
  ButtonModule,
  ButtonToggleModule,
  BreadcrumbsModule,
  CardDocModule,
  CardModule,
  CarouselModule,
  ChipsAutocompleteModule,
  CircularProgressModule,
  ClickOutsideDirectiveModule,
  ContextMenuModule,
  CursorModule,
  DialogModule,
  DrawerModule,
  ExpansionModule,
  FileDragAndDropModule,
  FlipCardModule,
  FooterModule,
  FormFieldModule,
  HeroBasicModule,
  LayoutModule,
  LayoutDualColModule,
  ListModule,
  LoadingOverlayModule,
  MainMenuModule,
  MenuButtonModule,
  NavbarModule,
  NavListModule,
  NotificationBarModule,
  ResizeObserverModule,
  ResourceCardModule,
  ResourceCarouselModule,
  SearchFieldModule,
  SelectBoxModule,
  SkeletonModule,
  SnackbarModule,
  StickyDrawerModule,
  TagModule,
  TagPickerModule,
  TextBoxModule,
  TopIconCardModule,
  ToolBarModule,
  FloatingActionsModule,
  ScrollTopModule,
  FloatingPanelModule,
  SelectorModule,
  RoutedLabelModule,
];

const publicStandalones = [
  IdleDialogComponent,
  AlertLiteComponent,
  ImageComponent,
  InitialsPipe,
  LinkDirective,
  LogoComponent,
  MatTableAddonsDirective,
  MatAutocompleteAddonsDirective,
  NavigateBackDirective,
  NegatePipe,
  PreventBubbleDirective,
  SmartGridComponent,
  StretchedLinkDirective,
  StringColorPipe,
  ThemeColorDirective,
  TimesWithPipe,
  ValuesByPipe,
  ConfirmationDialogComponent,
  MatTooltipAddonsDirective,
  MatCheckboxAddonsDirective,
  AddressPipe,
  FaqToolbarComponent,
  LsosLogoComponent,
  NorwayLogoComponent,
  IndicatorComponent,
  DatepickerMaskDirective,
  LoadingDialogComponent,
  MatFormFieldYearPickerDirective,
  SignaturePadComponent,
  SignaturePadDatuUrlControlDirective,
  PartnerLogoComponent,
  KeyboardFocusDirective,
];

@NgModule({
  imports: [CommonModule, ...publicApi, ...publicStandalones],
  exports: [...publicApi, ...publicStandalones],
})
export class UiModule {}
